import React from 'react'
import { Box } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { makeStyles } from '@material-ui/styles'
import { DocumentIcon, CheckIcon } from '~/assets/icons'

export type DropInputIconProps = {
  hasFile: boolean,
  isCompleted: boolean
}

const useStyles = makeStyles({
  successIcon: {
    color: mutualTheme.palette.success.main
  },
  iconContainer: (props: DropInputIconProps) => ({
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    padding: mutualTheme.spacing(1),
    borderRadius: mutualTheme.spacing(1),
    backgroundColor: (props.isCompleted || props.hasFile) ? mutualTheme.palette.pastelGreen.main : mutualTheme.palette.grey[400]
  })
})

export const DropInputIcon: React.FC<DropInputIconProps> = (props) => {
  const { isCompleted, hasFile } = props
  const classes = useStyles(props)

  if (isCompleted || hasFile) {
    return (
      <Box className={classes.iconContainer}>
        <CheckIcon htmlColor={mutualTheme.palette.badgeTitleText.success.main} className={classes.successIcon} />
      </Box>
    )
  }
  return (
    <Box className={classes.iconContainer}>
      <DocumentIcon height={24} width={24} color='disabled' />
    </Box>
  )
}
